import { getApiBase } from "../utils/apiBase";
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";


const jsonHeaders = (): HeadersInit => ({
  "Content-Type": "application/json",
  "X-CSRFToken": Cookies.get("csrftoken") || "",
});

export interface ReportPlanItem {
  text: string;
  completed: boolean;
}

export interface ReportPlanState {
  projectId: number;
  title?: string | null;
  items: ReportPlanItem[];
  completedCount: number;
  totalCount: number;
  status: "empty" | "in_progress" | "complete";
  updatedAt: string | null;
}

export const getReportPlan = async (
  projectId: string,
  reportId: string,
): Promise<ReportPlanState | null> => {
  const res = await fetch(`${getApiBase()}/api/projects/${projectId}/reports/${reportId}/plan`, {
    method: "GET",
    credentials: "include",
    headers: jsonHeaders(),
  });
  if (!res.ok) throw new Error(await res.text());
  return (await res.json()).data;
};

export const useReportPlan = (
  projectId: string,
  reportId: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["report-plan", projectId, reportId],
    queryFn: () => getReportPlan(projectId, reportId),
    enabled: Boolean(projectId && reportId && enabled),
    staleTime: 10_000,
  });
};
